<i class="fa fa-question-circle icon-help" aria-hidden="true" tooltip="{{ key | translate }}" containerClass="tooltip-help"></i>